// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@store/Themes/common/mixins/common";

const clickable: Styleguide["clickable"] = {
    defaultProps: {
        css: focusStyles(),
    },
};

export default clickable;
